<template>
  <!-- v-show="transInfo.from === $store.state.locale" -->
  <div class="transform text">
    <p>{{ transInfo.trans_result.dst }}</p>

    <span><a-icon type="check-circle" theme="filled" />&nbsp;翻译成功</span>
  </div>
</template>
<script>
export default {
  name: 'TransformMsg',
  props: {
    transInfo: {
      type: Object,
      default: () => {
        return {
          from: '',
          to: '',
          trans_result: { dst: '', src: '' },
        }
      },
    },
  },
  mounted() {
    console.log('transInfo', this.transInfo)
  },
}
</script>
<style scoped lang="scss">
.transform {
  margin-top: 8px;

  > span {
    font-size: 8px;
    font-weight: 400;
    color: #999999;
    line-height: 11px;
    margin: 0 12px;
  }
}
</style>
